import { config } from "@repo/config";
import {
	RolesSettings,
	RolesSettingsSkeleton,
} from "@saas/organizations/components/RoleManagement/RolesSettings";
import { AdminOnlyNotice } from "@saas/settings/components/SettingsLayout";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { ClientOnly, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/roles",
)({
	head: () => ({ meta: [{ title: `Roles - ${config.appName}` }] }),
	component: OrganizationRolesPage,
});

function OrganizationRolesPage() {
	const { organization, isOrganizationAdmin } = Route.useRouteContext();

	if (!isOrganizationAdmin) {
		return <AdminOnlyNotice what="roles" />;
	}

	// Roles load through the Better Auth client, which only has the session
	// cookie in the browser: rendering them on the server always 401s.
	return (
		<ClientOnly fallback={<RolesSettingsSkeleton />}>
			<AsyncBoundary
				fallback={<RolesSettingsSkeleton />}
				errorFallback="inline"
			>
				<RolesSettings organizationId={organization.id} />
			</AsyncBoundary>
		</ClientOnly>
	);
}
